// Character limit for search field in autocomplete component for lists
export const CHAR_LIMIT_FOR_SEARCH: number = 3;

// List name typing debounce time
export const CREATE_LIST_NAME_TYPING_DEBOUNCE: number = 500;

// Error status code to be returned when user list info is not available in 'edit' & 'duplicate' modes
export const CUSTOM_ERROR_STATUS_CODE_LIST_INFO_NOT_AVAILABLE: number = 456;

// Error status code to be returned when user list limit reached
export const CUSTOM_ERROR_STATUS_CODE_LIST_LIMIT_REACHED: number = 455;

// Default value for max number of items that can be edited
export const DEFAULT_ITEM_EDIT_LIMIT: number = 200;

// Default value for list limit in case api call fails or returns invalid response
export const DEFAULT_LIST_LIMIT: number = 5;

// Default value for list items limit in case api call fails or returns invalid response
export const DEFAULT_LIST_ITEMS_LIMIT: number = 20;

// Default value for tag limit in case api call fails or returns invalid response
export const DEFAULT_TAG_LIMIT: number = 10;

// Api calls default timeout value
export const LIST_API_TIMEOUT_VALUE: number = 12000;

// Maximum characters allowed in List name
export const LIST_NAME_CHAR_LIMIT: number = 30;

// Private list type ti-radio value
export const LIST_TYPE_PRIVATE: string = 'private';

// Shared list type ti-radio value
export const LIST_TYPE_SHARED: string = 'shared';

// Regex for valid list name pattern
export const VALID_LIST_NAME_PATTERN = '^(?!\\s*$)[\\w\\s-]+$';

// Supported modes for add to list
export type AddToListMode = 'upload' | 'opn-search' | 'list-search' | 'create-list';

// Supported error modes for add to list component
export type AddToListErrorContext = 'list-limit' | 'create-list-error' | 'init-error';

// Supported operation types for add to list component
export type AddToListOperations = 'modify-list' | 'modify-tags' | 'modify-items' | 'add-items' | 'remove-items';

// Create list mode context
export type CreateListMode = 'create' | 'edit' | 'duplicate';

// Supported Http Method types
export type HttpMethodType = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

// TO DO: might want to import interfaces from @ticom/list-manager-components
export interface AppSettings {
    enabledInvCGX: number;
    maxInvCallsPerTIer: number;
    maxInvCallsPerDirect: number
    maxInvCallsPerMassMarket: number;
    maxInvCallsPerCGX: number;
    maxInvPartsPerCall: number;
    maxItemPerListTIer: number;
    maxItemPerListDirect: number;
    maxItemPerListMassMarket: number;
    maxItemPerListCGX: number;
    maxListPerTIer: number;
    maxListPerDirect: number;
    maxListPerMassMarket: number;
    maxListPerCGX: number;
    maxTagsPerList: number;
    enabledUploadCGX: number;
    enabledDcofCGX: number;
    maxDcofCallsPerTIer: number;
    maxDcofCallsPerDirect: number;
    maxDcofCallsPerMassMarket: number;
    maxDcofCallsPerCGX: number;
    maxDcofPartsPerCall: number;
}

export interface ListInfo {
    listId: number;
    name: string;
    type: string;
    quantityMultiplier: number;
    createdDate: string;
    modifiedDate: string;
    modifiedBy: string;
    ownerPermId: string;
    ownerName: string;
    sharedCpId: number;
    items: ListItem[];
    totalItemCount: number;
    maxItemLimit: number;
    nextPageItemIndex: number;
    tags: TagInfo[];
    errors?: string[];
    salesConsent: boolean;
}

export interface ListItem {
    itemId: number;
    listId: number;
    partId: string;
    partNumber: string;
    type: string;
    customerReferenceNumber: string;
    quantity: number;
    itemInfo: ListItemInfo;
}

export interface ListItemInfo {
    getListItemInfo?: () => void;
}

export interface TagInfo {
    tagId: number;
    listId: number;
    name: string;
}

export interface UserInfo {
    permId: number;
    email: string;
    currentCpId: number;
    childCompanies: Map<number, string>;
    isInternal: boolean;
    role: string;
    isCGX: boolean;
    userType: string;
}

export interface MyTiListManagerBasicEventDetail {
    contextId: string;
}

export interface MyTiListManagerErrorEventDetail extends MyTiListManagerBasicEventDetail {
    errorCode: number;
    errorMsg: string;
}

export interface MyTiCreateListEditSuccessEventDetail extends MyTiListManagerBasicEventDetail {
    editedList: ListInfo;
}

export interface MyTiCreateListSuccessEventDetail extends MyTiListManagerBasicEventDetail {
    createdList: ListInfo;
}

export interface MyTiCreateListValidNameChangeEventDetail extends MyTiListManagerBasicEventDetail {
    isListNameValid: boolean;
}

export interface MyTiCreateListEditValidChangeEventDetail extends MyTiListManagerBasicEventDetail {
    isEditValid: boolean;
}

export interface MyTiSearchListSelectedEventDetail extends MyTiListManagerBasicEventDetail {
    selectedList: ListInfo;
    modifiedTags: boolean;
}

export interface MyTiBulkAddtoListEventDetail extends MyTiListManagerBasicEventDetail {
    isValid: boolean;
    action: AddToListMode;
}

export interface MyTiAddToListEventDetail extends MyTiListManagerBasicEventDetail {
    error?: boolean;
    listOnSuccess?: ListInfo;
    newItems?: ListItem[];
    oldItems?: ListItem[];
    operations?: AddToListOperations[];
}
